import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'components';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = () => ({
	categoryTitle: {
		fontWeight: 500,
		color: "#000000",
		fontSize: '0.80rem'
	},
	active: {
		color: '#4695ec !important', 
		fontWeight: 500,
		fontSize: '0.80rem'
	}
});

const ListCategories = ({ classes, products, handleClick, categoryFilter }) => { 
	return (
		products.length > 0 && (
			products.map(category => {
				return(	  
				<div>
					<ListItem
						key={category}
						style={{paddingLeft: 20, paddingRight: 10}}
						button
						onClick={handleClick}
						>
						<ListItemText
							classes={{
								primary: (categoryFilter && category === categoryFilter.trim())? classes.active : classes.categoryTitle,
							}}
							primary={category}
						/>
					</ListItem>
				</div>
				)}
			)
		)
	);
};

ListCategories.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	products: PropTypes.array,
	categoryFilter: PropTypes.string,
	handleClick: PropTypes.func,
};

export default compose(
	setDisplayName('ListCategories'),
	injectIntl,
	withStyles(styles),
)(ListCategories);
